import {
  GetMonthlyClouserReportResponseSchema,
  type GetMonthlyClouserReportResponsePayload,
} from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useMonthlyClosureReport(
  reportId?: string,
  options?: CustomUseQueryOptions<GetMonthlyClouserReportResponsePayload>,
) {
  const queryKey = queryKeys.monthlyClosureReport(reportId);
  const getMonthlyClosureReportQuery = useQuery(
    queryKey,
    async () => {
      const api = getPrivateApi();
      const getMonthlyClosureReportResponse = await api.getMonthlyClouserReport({ reportId });

      return GetMonthlyClouserReportResponseSchema.parse(getMonthlyClosureReportResponse);
    },
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(getMonthlyClosureReportQuery.data, 'getMonthlyClosureReportQuery data');

  return getMonthlyClosureReportQuery;
}
